/* eslint-disable */
// prettier-ignore

import { get } from "lodash"
import apps from "../../../../router/routes/apps"

let appPages = []

apps.forEach((app) => {
  const searchable = get(app, 'meta.searchable', true)
  if (searchable) {
    appPages.push({
      title: get(app, 'meta.pageTitle'),
      route: {
        name: get(app, 'name')
      },
      icon: get(app, 'meta.icon', 'CircleIcon'),
      isBookmarked: false
    })
  }
})

export default {
  pages: {
    key: 'title',
    data: [
      // { title: 'Usuários', route: { name: 'users' }, icon: 'UserIcon', isBookmarked: false },
      // { title: 'Grupos', route: { name: 'roles' }, icon: 'UsersIcon', isBookmarked: false },
      ...appPages
    ],
  }
}
/* eslint-enable */
